import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getComplaintForAdminDept = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForAdminDept",
    params
  );
};

export { getComplaintForAdminDept };
